import * as React from "react";
import { SVGAttributes } from "react";

export const GuardIcon = React.memo(
  ({
    size = 24,
    color = "#4E5361",
    ...props
  }: SVGAttributes<SVGElement> & {
    size?: number,
  }) => {
    return (
      <svg width={size} height={size} fill="none" {...props}>
        <path
          d="M5.592 7.634c-.509.142-.953.344-.953.977 0 10.279 0 18.691 2.488 25.326 2.53 6.766 7.565 11.576 17.606 14.426a.935.935 0 00.516 0c10.07-2.85 15.089-7.666 17.624-14.426 2.459-6.558 2.488-14.81 2.488-24.923 0-.557 0-1.113-.687-1.309a71.74 71.74 0 00-39.1-.071h.018z"
          fill="#8F8F8F"
        />
        <path
          d="M49.313 3.398A88.637 88.637 0 00.972 3.32c-.51.136-.972.326-.972.983 0 12.708 0 23.11 3.08 31.262 3.099 8.335 9.296 14.254 21.66 17.749a.935.935 0 00.515 0c12.363-3.513 18.56-9.437 21.676-17.731C49.964 27.509 50 17.266 50 4.778c0-.574.024-1.179-.687-1.38zm-4.17 31.54C42.292 42.616 36.522 48.12 25 51.443 13.477 48.119 7.76 42.65 4.858 34.938c-2.903-7.713-2.962-17.72-2.962-29.917a86.628 86.628 0 0146.208-.006c0 12.204-.112 22.245-2.962 29.923z"
          fill="#8F8F8F"
        />
      </svg>
    );
  }
);
